import { useTranslation } from "react-i18next";
export default function ErrorPage(){
  const { t } = useTranslation(["common"]);
  return (
    <h1 style={{margin:"20px"}}>{t("common:somethingWentWrong")}.</h1>
  );
};

